import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useBootstrapStore = defineStore('bootstrap', () => {
  // Raised when bootstrap failed for a reason a logout cannot fix (outage,
  // network blip): the session is kept and the app renders a full-screen
  // reload gate instead of the router. Deliberately not persisted so the
  // user-initiated reload starts from a clean slate.
  const hasBlockingError = ref(false);

  return {
    hasBlockingError,
  };
});
